/**
 * ciclo-cart-shipping.js
 * ──────────────────────
 * Live-updates the free-shipping progress bar (#ciclo-fs-bar) whenever the
 * cart changes. Works with Dawn's cart-drawer.js which dispatches a
 * 'cart:refresh' custom event (via pubsub.js subscribe) and also updates the
 * cart-drawer DOM via renderContents().
 *
 * Strategy: subscribe to Dawn's PubSub 'cart:refresh' event, then re-fetch
 * /cart.js to get the current total and re-render the bar.
 *
 * No jQuery, no external deps. ~1.5 KB minified.
 */

(function () {
  'use strict';

  const BAR_ID = 'ciclo-fs-bar';

  /**
   * Read the threshold from data-threshold on the bar element (paise).
   * This is set server-side by Liquid so we don't need to pass it separately.
   */
  function getThreshold() {
    const bar = document.getElementById(BAR_ID);
    return bar ? parseInt(bar.dataset.threshold, 10) : 0;
  }

  /**
   * Re-render the bar based on a cart total (in paise / Shopify money units).
   * @param {number} cartTotal - cart.total_price in paise
   */
  function updateBar(cartTotal) {
    const bar = document.getElementById(BAR_ID);
    if (!bar) return;

    const threshold = getThreshold();
    if (!threshold) return;

    const gap        = Math.max(threshold - cartTotal, 0);
    const progressPct = Math.min(Math.round((cartTotal / threshold) * 100), 100);
    const fill       = bar.querySelector('.ciclo-fs-bar__fill');
    const track      = bar.querySelector('.ciclo-fs-bar__track');
    const msg        = bar.querySelector('.ciclo-fs-bar__msg');

    // Show bar (it starts hidden when cart is empty)
    bar.classList.remove('ciclo-fs-bar--hidden');

    // Update progress fill
    if (fill) fill.style.width = progressPct + '%';
    if (track) {
      track.setAttribute('aria-valuenow', progressPct);
    }

    // Update message
    if (msg) {
      if (gap === 0) {
        msg.classList.add('ciclo-fs-bar__msg--unlocked');
        msg.innerHTML = '<svg width="15" height="15" viewBox="0 0 16 16" fill="none" aria-hidden="true"><circle cx="8" cy="8" r="7.25" stroke="currentColor" stroke-width="1.5"/><path d="M4.5 8.25L6.75 10.5L11.5 5.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg> You\'ve unlocked free shipping! 🎉';
      } else {
        msg.classList.remove('ciclo-fs-bar__msg--unlocked');
        // Format gap as ₹ — Shopify money is in paise (× 100 already)
        const gapFormatted = '₹' + (gap / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        msg.innerHTML = 'Add <strong>' + gapFormatted + '</strong> more for free shipping';
      }
    }
  }

  /**
   * Fetch current cart and update bar.
   */
  function refreshFromCart() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) { updateBar(cart.total_price); })
      .catch(function () { /* fail silently */ });
  }

  /**
   * Initialise once DOM is ready.
   */
  function init() {
    const bar = document.getElementById(BAR_ID);
    if (!bar || !getThreshold()) return;

    // Dawn 15 announces every cart change through pubsub as PUB_SUB_EVENTS.cartUpdate ('cart-update').
    if (typeof subscribe === 'function') {
      subscribe(typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS.cartUpdate : 'cart-update', refreshFromCart);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
